// components/PrivateRoute.js
// Route guard — redirect to login if not authenticated
// Optional: requireAdmin — redirect to dashboard if not admin
//
// שימוש:
//   <Route element={<PrivateRoute />}> ... </Route>
//   <Route element={<PrivateRoute requireAdmin />}> ... </Route>

import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Loading from './shared/Loading';

export default function PrivateRoute({ requireAdmin = false }) {
  const { isAuthenticated, isLoading, isAdmin } = useAuth();

  // עדיין בודק auth status — הצג loading
  if (isLoading) {
    return <Loading fullPage />;
  }

  // לא מאומת — redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // דורש admin אבל המשתמש לא admin — redirect to dashboard
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
